import React from 'react';
import { WhatsAppButton } from './WhatsAppButton';
export function FinalCTA() {
  return <section id="cotizar" className="py-24 bg-white relative overflow-hidden scroll-mt-24" data-id="element-10">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-blue-50 transform -skew-y-3 z-0" data-id="element-11"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-12">
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 tracking-tight" data-id="element-13">
          Have a deadline-driven filing?
        </h2>
        <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-14">
          Don't risk your case with uncertified translations. Get a quote today
          and receive your document ready to submit.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-15">
          <WhatsAppButton size="lg" className="w-full sm:w-auto shadow-xl" data-id="element-16" />
        </div>

        <p className="mt-6 text-sm text-gray-500 font-medium" data-id="element-17">
          Average response time: under 15 minutes during business hours.
        </p>
      </div>
    </section>;
}